import usePageLayout from '../../hooks/usePageLayout';
import React, { useRef, useState } from 'react';
import { Layout, Space, Row, Button, Col } from 'antd';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import AuthButtonGoogleCustom from '../../components/AuthButtonGoogleCustom';
import AuthButtonApple from '../../components/AuthButtonApple';
import SocialAuthButtons from '../../socialAuth';
import WiwHeaderTitle from '../../components/WiwHeaderTitle';
import { HomeIcon, SquareIcon, CheckSquareIcon } from '../../components/Brand/Icon';
import { APP_ROUTES } from '../../utils/constant';
import { Helmet } from 'react-helmet';
import url from '../../utils/url';
import './index.scss';

const { Header, Content } = Layout;

export default function Login() {
  const headerRef = useRef(null);
  const { contentHeight, contentTop } = usePageLayout(headerRef);
  const { t } = useTranslation();
  const { t: brand } = useTranslation('brand');
  const [consent, setConsent] = useState(false);
  const [socialBusy, setSocialBusy] = useState(false);
  const navigate = useNavigate();

  return (
    <Layout className="app-layout login_page">
      <Helmet>
        <title>{t('login.title')}</title>
        <meta name="description" content={t('login.title')} />
      </Helmet>
      <Header className="header" ref={headerRef}><WiwHeaderTitle title={t('login.title')}></WiwHeaderTitle></Header>
      <Content className='content-layot content-layout' style={{ height: contentHeight, top: contentTop }}>
        <Row justify="center" align="middle" style={{ width: '100%' }}>
          <Col span={24}>
            <Space direction="vertical" className='login_buttom' size={8} style={{ width: '100%' }}>
              <AuthButtonGoogleCustom disabled={!consent || socialBusy} />
              <AuthButtonApple disabled={!consent || socialBusy} />
              <SocialAuthButtons disabled={!consent} onBusy={setSocialBusy} />
              <Button
                style={{ width: '100%' }}
                className='button_border'
                onClick={() => navigate(url('/'))}
                icon={<HomeIcon />}
              >
                {t('login.button_skip')}
              </Button>
              <label className="privacy_wrap" htmlFor="login-consent">
                {t('login.consent')} <Link to={url(`${APP_ROUTES.STATIC}/terms`)}>{t('login.terms')}</Link> {t('login.and')} <Link to={url(`${APP_ROUTES.STATIC}/privacy`)}>{t('login.privacy')}</Link>
              </label>
              <label className="login-consent-control">
                <input id="login-consent" type="checkbox" checked={consent}
                  aria-label={brand('authConsentLabel')} onChange={(event) => setConsent(event.target.checked)} />
                {consent ? <CheckSquareIcon size={32} filled /> : <SquareIcon size={32} />}
              </label>
            </Space>
          </Col>
        </Row>
      </Content>
    </Layout>
  )
}
